/**
 * Download de arquivo gerado no servidor.
 *
 * O padrão do produto é o tRPC devolver a string do arquivo no JSON e o browser
 * montar o Blob — não há rota Express de download. Esta função existia copiada
 * em três telas; a terceira cópia já tinha esquecido o `revokeObjectURL` e
 * segurava o Blob inteiro em memória até o reload.
 */

/**
 * O CSV vem do servidor já com BOM UTF-8 (ver `server/_core/csv.ts`).
 * NÃO acrescente "\uFEFF" aqui: dois BOMs colados fazem o Excel exibir "ï»¿"
 * na primeira célula do cabeçalho.
 */
export function downloadCsv(csv: string, fileName: string): void {
  downloadBlob(new Blob([csv], { type: "text/csv;charset=utf-8" }), fileName);
}

export function downloadBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
